<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="control mt1">
        <masked-input
          class="input"
          type="tel"
          name="phone"
          placeholder="Phone"
          placeholderChar="_"
          :mask="[
            /[1-9]/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            /\d/,
            /\d/
          ]"
          v-model="choice"
          @keyup.native="recordAnswer"
        >
        </masked-input>
      </div>

      <next-button :id="question.id" :choice="choice"></next-button>
    </div>
  </div>
</template>

<script>
import maskedInput from "vue-text-mask";
import baseQuestion from "./baseQuestion";

export default {
  name: "phone",

  mixins: [baseQuestion],

  components: {
    maskedInput
  },

  methods: {
    recordAnswer(e) {
      const phone = e.target.value;
      if (/\d{3}-\d{3}-\d{4}/.test(phone)) {
        this.choice = phone;
        this.$store.dispatch("interview/setNext", true);
      } else {
        this.$store.dispatch("interview/setNext", false);
      }
    }
  }
};
</script>
